import ChipRoot, { Props, Ref } from './Chip'
import { forwardRef } from 'react'

function Chip(props: Props, ref?: Ref) {
  return <ChipRoot {...props} ref={ref} />
}

export default forwardRef(Chip)
